import { render, staticRenderFns } from "./InstructionCard.vue?vue&type=template&id=11f574fd&scoped=true"
import script from "./InstructionCard.vue?vue&type=script&lang=js"
export * from "./InstructionCard.vue?vue&type=script&lang=js"
import style0 from "./InstructionCard.vue?vue&type=style&index=0&id=11f574fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f574fd",
  null
  
)

export default component.exports